module.exports = __webpack_public_path__ + "resources/img/img_datahunt5.20c835ef305f6cd7714c7d66197564db.png";